import React from 'react';
import './index.scss';
import clsx from 'clsx';

import PcPopUp from 'components/molecules/PcPopUp';
import RequiredOrOptionalIcon from '../../atoms/Icon/RequiredOrOptionalIcon';

const PcInputItem = ({
    title,
    // list = [],
    children,
    invisible,
    label,
    questionMark,
    popUpTitle,
    popUpDetail,
    // type
}) => {
    const DispTitle = () => {
        return Array.isArray(title)
            ? title.map(line => (
                <span key={line} className="">
                    {line}
                    <br />
                </span>
            ))
            : <>{title}</>;
    };

    // const DispChild = () => {
    //     switch (type) {
    //         case 'TextInput': return (
    //             <Textbox list={list} />
    //         ); break;
    //         case 'RadioInput': return (
    //             <Radiolist list={list} />
    //         ); break;
    //         default: return null;
    //     }
    // };

    // const Radiolist = ({ list: detail }) => {
    //     return (
    //         <div className="">
    //             {detail.map(data => (
    //                 <span className="radioInput">
    //                     <RadioInput
    //                         id={data.id}
    //                         value={data.value}
    //                         onChange={data.onChange}
    //                         checked={data.checked}
    //                         label={data.label} />
    //                 </span>
    //             )
    //             )}
    //         </div>
    //     )
    // };

    // const Textbox = ({ list: detail }) => {
    //     return (
    //         <div className="">
    //             {detail.map(data => (
    //                 <span className="">
    //                     <TextInput
    //                         name={data.name}
    //                         placeholder={data.placeholder}
    //                     />
    //                 </span>
    //             )
    //             )}
    //         </div>
    //     )
    // };
    return (
        !invisible&&
        <div className="PcInputItem">
            <div className="PIA-title">
                <DispTitle />
                {<RequiredOrOptionalIcon label={label} />}
                <span 
                    className={clsx('RequiredOrOptionalIcon',
                        { qShow: questionMark === false })}>
                    <PcPopUp title={popUpTitle} children={popUpDetail}/>
                </span>
            </div>
            <span className="PIA-item">
                {/* <DispChild /> */}
                {children}
            </span>
        </div>
    );
};

export default PcInputItem;